/**
 * knowledgeApi — la base de conocimiento del proyecto, desde el admin.
 *
 * Envoltorio fino sobre /api/knowledge. Cada helper devuelve el cuerpo ya
 * parseado y deja pasar el error tal cual, para que la pantalla lo pinte con
 * `formatError(e)` como el resto del admin.
 *
 * Las fuentes DINÁMICAS se leen aparte y no tienen helpers de escritura: no
 * se editan desde aquí a propósito. Quien quiera corregir la disponibilidad
 * tiene que ir a cambiar el estado de la villa, que es donde ese dato vive.
 */
import { api } from "@/lib/api";

const BASE = "/knowledge";

export async function listKnowledgeFacts({ category, status, q } = {}) {
  const params = {};
  if (category) params.category = category;
  if (status) params.status = status;
  if (q) params.q = q;
  const { data } = await api.get(BASE, { params });
  return {
    items: Array.isArray(data?.items) ? data.items : [],
    categories: Array.isArray(data?.categories) ? data.categories : [],
    statuses: Array.isArray(data?.statuses) ? data.statuses : [],
  };
}

/** Las proyecciones canónicas de solo lectura, con su dueño. */
export async function listKnowledgeDynamic() {
  const { data } = await api.get(`${BASE}/dynamic`);
  return Array.isArray(data?.items) ? data.items : [];
}

export async function createKnowledgeFact(payload) {
  const { data } = await api.post(BASE, payload);
  return data;
}

export async function updateKnowledgeFact(factId, patch) {
  const { data } = await api.patch(`${BASE}/${factId}`, patch);
  return data;
}

export async function approveKnowledgeFact(factId) {
  const { data } = await api.post(`${BASE}/${factId}/approve`, {});
  return data;
}

export async function retireKnowledgeFact(factId) {
  const { data } = await api.post(`${BASE}/${factId}/retire`, {});
  return data;
}

/** Carga los candidatos del catálogo. Siempre como borrador, nunca pisa nada. */
export async function bootstrapKnowledgeFacts() {
  const { data } = await api.post(`${BASE}/bootstrap`, {});
  return data;
}
